import { render, staticRenderFns } from "./_proxyLog.vue?vue&type=template&id=4f677c7b&scoped=true&lang=pug&"
import script from "./_proxyLog.vue?vue&type=script&lang=js&"
export * from "./_proxyLog.vue?vue&type=script&lang=js&"
import style0 from "./_proxyLog.vue?vue&type=style&index=0&id=4f677c7b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f677c7b",
  null
  
)

export default component.exports